export type ChatTranslations = {
  error: {
    messageFailed: string;
    noChatId: string;
    requestTimeout: string;
  };
};

export const chatTranslations: ChatTranslations = {
  error: {
    messageFailed: 'Wystąpił błąd podczas przetwarzania wiadomości.',
    noChatId:
      'Czat nie został zainicjowany. Odśwież stronę i spróbuj ponownie. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.',
    requestTimeout: 'Przetwarzanie żądania przekroczyło limit czasu.',
  },
};
